import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../../themes/default';

const styles = theme => ({
  root: {
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
    borderRadius: theme.spacing.unit / 2,
    background: theme.palette.grey[50],
    border: `1px solid ${ theme.palette.grey[200] }`
  }
});

const TabHead = ({children, classes}) => {
  return (
    <div className={ classNames( "Tab-Head", classes.root )}>
      { children }
    </div>
  )
}

TabHead.propTypes = {
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(TabHead);
